import axios from "axios";
import { getCookie } from "../helperFunctions/cookie";

const baseUrl = `${process.env.REACT_APP_API_IP}/api/v1/appearance`;

export const getAppearance = async () => {
  const token = getCookie();
  const userId = JSON.parse(localStorage.getItem("user"))._id;
  try {
    const res = await axios.get(baseUrl, {
      withCredentials: true,
      headers: { authorization: "Bearer " + token },
    });
    localStorage.setItem("appearance", JSON.stringify(res.data.appearance[0]));
  } catch (error) {}
};

// export const createAppearance = async (todoId) => {
//   const token = getCookie();
//   const userId = JSON.parse(localStorage.getItem("user"))._id;
//   try {
//     const res = await axios.post(
//       baseUrl,
//       {
//         userId,
//         listShortcuts: [{ title: "To Do", listId: todoId }],
//       },
//       { withCredentials: true, headers: { authorization: "Bearer " + token } }
//     );
//     console.log(res.data);
//     localStorage.setItem("appearance", res.data);
//   } catch (error) {
//     console.log(error);
//   }
// };

export const updateListShortcuts = async (listShortcuts, userId) => {
  const token = getCookie();
  try {
    const res = await axios.patch(
      baseUrl,
      { userId, listShortcuts: listShortcuts },
      {
        withCredentials: true,
        headers: { authorization: "Bearer " + token },
      }
    );
    localStorage.setItem("appearance", JSON.stringify(res.data.appearance));
  } catch (error) {}
};
